
import wx from 'weixin-js-sdk'
// console.log("wx:%o", wx)
import auth from '../auth'
// console.log("auth:%o", auth)

import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'

import Loading from 'vux/src/components/loading/index.vue'
import Divider from 'vux/src/components/divider/index.vue'
import Card from 'vux/src/components/card/index.vue'


export default {
  components: {
    Loading,
    Group,
    Cell,
    Card,
    Divider
  },
  data () {
      return {
          show1: true,
          text1: '加载中',
          transitionName: 'slide-left',

          coins: 0,
          name: "",
          portrait: null,

          reqWxJSSignUrl: 'http://alphago.chemucao.cn/real/api/index.php/jsapi/sign',
          reqWxPaySignUrl: 'http://alphago.chemucao.cn/real/api/index.php/wxpay/jsapi',

          wx_appId: null,
          wx_timestamp: null,
          wx_nonceStr: null,
          wx_signature: null,

          wxp_nonceStr: null,
          wxp_package: null,
          wxp_paySign: null,
          wxp_signType: null,
          wxp_timeStamp: null,

          autopay:0,
          token: null, //'alphago_admin_debug',
          openid: null,//'ocwMjv_FhbsJTkhUNhAU7koY64Ps',
          community: ''
      }
  },
  mounted() {
    // console.log("mounted")
  },
  created() {
    console.log(">>> home head state state:%o",this.$store.state)
    console.log("created currentRoute:%o", this.$root.currentRoute)
    console.log(">>> route.query:%o",this.$route.query)
    if(typeof(this.$route.query.autopay)!= "undefined"){
      this.autopay = this.$route.query.autopay
      console.log("autopay enable:%s", this.autopay)
    }
    let code = this.getParameterByName("code")
    console.log("code:%s", code)
    let state = this.getParameterByName("state")
    console.log("state:%s", state)
    this.loginUrl(code, state)
  },
  methods: {
    getParameterByName: function(name) {
        name = name.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]");
        var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
        results = regex.exec(location.search);
        return results == null ? "": decodeURIComponent(results[1]);
    },
    loginUrl: function(code, state){
      if(code.length == 0){
        this.openid = auth.getOpenid()
        this.coins = auth.getCoins()
        this.name = auth.getName()
        this.portrait = auth.getPortrait()
        this.token = auth.getToken()
        let as = "loginUrl! openid:"+ this.openid +", token:"+ this.token
        console.log(as)
        this.reqWxJSSign()
        // this.wxPayReg(1)
        return
      }
      if(state.length == 0){
        state = "gzh"
      }
      console.log("loginUrl: length code:%d, state:%d", code.length, state.length)
      let url = "http://alphago.chemucao.cn/real/api/index.php/user/login"
      let req_data = {code:code, state:state}
      console.log("loginUrl url:%s, req_data:%o", url, req_data)
      this.$http.post(url, req_data).then((res) => {
        console.log("PASS! response:%o", res);
        // console.log("status%s", res.status);
        // console.log("statusText:%s", res.statusText);
        // console.log("Expires: %s", res.headers.get('Expires'));
        // console.log("body: %o", res.body);
        res = res.body
        console.log("successful res:%o", res);
        console.log("code:" + res.code + ",typeof:" + typeof(res.code))
        let res_data = res.data;
        console.log("res_data:%o", res_data);
        if( res.code === 0 ){
          this.openid = res_data.openid
          this.coins = res_data.coin
          this.name = res_data.name
          this.portrait = res_data.portrait
          this.token = res_data.token
          // Gtoken ＝ res_data.token
          console.log("openid:%s, token%s, coins:%s, name:%s, portrait:%s ", this.openid, this.token, this.coins, this.name, this.portrait)
          auth.setOpenid(this.openid)
          auth.setCoins(this.coins)
          auth.setName(this.name)
          auth.setPortrait(this.portrait)
          auth.setToken(this.token)
          this.reqWxJSSign()
          // this.wxPayReg(1)
        }
        let as = "loginUrl! openid:"+ this.openid +", token:"+ this.token +", coins:"+ this.coins +", name:" + this.name + ", portrait:" + this.portrait
        console.log(as);

      }, (response) => {
        // error callback
        var as = "loginUrl fail!!! response:" + response
        console.error(as);
      });
    },
    regWxPay: function(){
      console.log("regWxPay");
      console.log("wxp_nonceStr:%s, wxp_package:%s, wxp_paySign:%s, wxp_signType:%s, wxp_timeStamp:%s", this.wxp_nonceStr, this.wxp_package, this.wxp_paySign, this.wxp_signType, this.wxp_timeStamp);
      wx.chooseWXPay({
        debug: false,
        timestamp: this.wxp_timeStamp,
        nonceStr: this.wxp_nonceStr,
        package: this.wxp_package,
        signType: this.wxp_signType,
        paySign: this.wxp_paySign,
        success: function (res) {
          console.log("pay successful!"+res);
        },
        error: function(json){
          console.error("pay failed:"+json);
        }
      });
    },
    reqWxPaySign: function(){
      var url = this.reqWxPaySignUrl
      let para = {
        'openid':this.openid, 'token':this.token, 'money':100
      }
      console.log("reqWxPaySign url:%s", url);
      this.$http.post(url, para).then((response) => {
        console.log("PASS! response:%o", response);
        console.log("status%s", response.status);
        console.log("statusText:%s", response.statusText);
        console.log("Expires: %s", response.headers.get('Expires'));
        console.log("body: %o", response.body);
        var dl = response.body.data;
        this.wxp_nonceStr = dl.nonceStr,
        this.wxp_package = dl.package,
        this.wxp_paySign = dl.paySign,
        this.wxp_signType = dl.signType,
        this.wxp_timeStamp = dl.timeStamp,
        console.log("wxp_nonceStr:%s, wxp_package:%s, wxp_paySign:%s, wxp_signType:%s, wxp_timeStamp:%s", this.wxp_nonceStr, this.wxp_package, this.wxp_paySign, this.wxp_signType, this.wxp_timeStamp);

        if(this.autopay === '1'){
          console.log("start autopay")
          this.regWxPay();
        }
      }, (response) => {
        // error callback
        console.error("FAIL!!! response:%o", response);
      });
    },
    wxPayReg: function(money){
      console.log("wxPayReg: openid:%s, token:%s, money:%s", this.openid, this.token, money)
      let url = "http://alphago.chemucao.cn/real/api/index.php/wxpay/jsapi"
      let req_data = {openid:this.openid, token:this.token, money:money}
      console.log("wxPayReg url:%s, req_data:%o", url, req_data)
      this.$http.post(url, req_data).then((data) => {
        data = data.body
        console.log("wxPayReg successful data:%o", data)
        console.log("code:" + data.code + ",typeof:" + typeof(data.code))
        let res_data = data.data;
        console.log("res_data:%o", res_data)
        if(data.code === 0){
          console.log("res_data:%o", res_data)
          this.wx_appId = res_data.appId //'wxb475de346779fa67'
          this.wxp_nonceStr = res_data.nonceStr
          this.wxp_timeStamp = res_data.timeStamp
          this.wxp_package = res_data.package
          this.wxp_paySign = res_data.paySign
          this.wxp_signType = res_data.signType

          console.log("appId:%s, nonceStr:%s, timestamp:%s, package:%s, paySign:%s, signType:%s", this.wx_appId, this.wxp_nonceStr, this.wxp_timeStamp, this.wxp_package, this.wxp_paySign, this.wxp_signType)
          let msg = "appId" + this.wx_appId + "nonceStr:" + this.wxp_nonceStr + ", timestamp:" + this.wxp_timeStamp + ", package:" + this.wxp_package + ", paySign:" + this.wxp_paySign + ", signType:" + this.wxp_signType
          console.log(msg);
        }

      }, (response) => {
        let msg = "wxPayReg failed!!!" + response
        console.error(msg)
        // alert(msg);
      });
    },
    wxpaySubmit: function(){
      console.log("wxpaySubmit pay start")
      this.regWxPay()
      console.log("wxpaySubmit pay done")
      return
      console.log("wxpaySubmit pay overload")

      // wx.ready(function () {
        let msg = "nonceStr:" + this.wxp_nonceStr + ", timestamp:" + this.wxp_timeStamp + ", package:" + this.wxp_package + ", paySign:" + this.wxp_paySign + ", signType:" + this.wxp_signType
        //alert(msg);
        console.log("nonceStr;%s, timestamp:%s, package:%s, paySign:%s, signType:%s", this.wxp_nonceStr, this.wxp_timeStamp, this.wxp_package, this.wxp_paySign, this.wxp_signType)
        wx.chooseWXPay({
          timestamp: this.wxp_timeStamp,
          nonceStr: this.wxp_nonceStr,
          package: this.wxp_package,
          signType: this.wxp_paySign,
          paySign: this.wxp_signType,
          success: function (res) {
            let msg = "pay pass!" + res
            alert(msg);
          },
          error: function(json){
            let msg = "pay fail!!!" + json
            alert(msg);
          }
        });

      // });

    },
    submit: function(){
      console.log("submit community:%s", this.community);
      this.reqHouseArea(this.community);
      auth.setCm(this.community);
    },
    regWxJsApi: function(){
      console.log("regWxJsApi");
      console.log("wx_appId:%s, wx_timestamp:%d, wx_nonceStr:%s, wx_signature:%s", this.wx_appId, this.wx_timestamp, this.wx_nonceStr, this.wx_signature);
      wx.config({
        debug: false,
        appId: this.wx_appId,
        timestamp: this.wx_timestamp,
        nonceStr: this.wx_nonceStr,
        signature: this.wx_signature,
        jsApiList: [
          'getLocation',
          'onMenuShareTimeline',
          'onMenuShareAppMessage',
          'onMenuShareQQ',
          'onMenuShareWeibo',
          'onMenuShareQZone',
          'chooseWXPay'
        ],
        success: function (res) {
          console.log("config successful!" + res)
        },
        error: function(json){
          console.error("config failed:" + json)
        }
      });
      this.reqWxPaySign()

      wx.ready(function () {
        console.log("wx.ready!")
        wx.checkJsApi({
          jsApiList: [
            'getLocation',
            'onMenuShareTimeline',
            'onMenuShareAppMessage',
            'onMenuShareQQ',
            'onMenuShareWeibo',
            'onMenuShareQZone',
            'chooseWXPay'
          ],
          success: function (res) {
            console.log(JSON.stringify(res))
          },
          error: function(json){
            let msg = "config failed:" + json
            alert(msg)
          }
        });
        wx.getLocation({
          success: function (res) {
            console.log("res:%o", res)
            // let res_data = JSON.stringify(res)
            let res_data = res
            console.log(res_data);
            let latitude = res_data.latitude
            let longitude = res_data.longitude
            let speed = res_data.speed
            let accuracy = res_data.accuracy
            //alert(latitude)
            // alert(longitude)
            console.log("latitude:%s, longitude:%s, speed:%s, accuracy:%s",latitude, longitude, speed, accuracy)
            auth.setLat(latitude)
            auth.setLongt(longitude)

          },
          cancel: function (res) {
            alert('用户拒绝授权获取地理位置');
          }
        });


      });
    },
    reqWxJSSign: function(){
      var local_url = location.href.split('#')[0];
      console.log("reqWxJSSign local_url:%s", local_url);
      var url = this.reqWxJSSignUrl
      // var url = 'http://alphago.chemucao.cn/real/api/index.php/jsapi/sign'
      console.log("reqWxJSSign url:%s", url)
      var parameter = {'openid':this.openid,'token':this.token, 'url':local_url}
      console.log("reqWxJSSign parameter:%o", parameter);
      this.$http.post(url, /*{foo:"bar"}*/parameter).then((response) => {
        // console.log("PASS! response:%o", response);
        // console.log("status%s", response.status);
        // console.log("statusText:%s", response.statusText);
        // console.log("Expires: %s", response.headers.get('Expires'));
        console.log("reqWxJSSign body: %o", response.body);
        var dl = response.body.data;
        console.log("reqWxJSSign dl:"+dl)
        this.wx_appId = dl.appId;
        this.wx_timestamp = dl.timestamp;
        this.wx_nonceStr = dl.nonceStr;
        this.wx_signature = dl.signature;
        console.log("reqWxJSSign wx_appId:%s, wx_timestamp:%d, wx_nonceStr:%s, wx_signature:%s", this.wx_appId, this.wx_timestamp, this.wx_nonceStr, this.wx_signature);
        // test
        // auth.setLat(30.577927)
        // auth.setLongt(114.03084)
        this.regWxJsApi();
        // hide loading
        this.show1 = false;
      }, (response) => {
        // error callback
        console.error("reqWxJSSign FAIL!!! response:%o", response);
      });
    }
  },
  watch: {
    '$route' (to, from) {
      const toDepth = to.path.split('/').length
      const fromDepth = from.path.split('/').length
      this.transitionName = toDepth < fromDepth ? 'slide-right' : 'slide-lef'
    }
  }/*,
  components: {
    MainLayout
  }*/
}



// WEBPACK FOOTER //
// ./src/components/HomeHead.vue